import { useEffect, useMemo, useState } from 'react'
import { MiniLoader } from '../Common/MiniLoader'
import { Button } from '../Common/Button'
import { useNls } from '../../nls/nlsProvider'

export const AgentThinkingIndicator = ({
  label,
  labels,
  onAbort,
  rotationMs = 2000,
}: {
  label?: string
  labels?: string[]
  onAbort?: () => void
  rotationMs?: number
}) => {
  const { t } = useNls()
  const sequence = useMemo(() => {
    if (labels && labels.length > 0) return labels
    if (label) return [label]
    return [t('NLSAiThinkingDefault')]
  }, [labels, label, t])
  const [index, setIndex] = useState(0)

  useEffect(() => {
    setIndex(0)
    if (sequence.length <= 1) return
    const timer = window.setInterval(() => {
      setIndex((current) => Math.min(current + 1, sequence.length - 1))
    }, rotationMs)
    return () => window.clearInterval(timer)
  }, [sequence, rotationMs])

  const active = sequence[index] ?? sequence[0]
  return (
    <div className="lineFlatThinking" role="status" aria-live="polite" aria-label={active}>
      <div className="lineFlatThinking__row">
        <MiniLoader tone="ai" size="md" label={active} />
        {onAbort && (
          <Button
            size="sm"
            variant="tertiary"
            className="lineFlatThinking__abort"
            onClick={onAbort}
          >
            {t('NLSAiActionStop')}
          </Button>
        )}
      </div>
    </div>
  )
}
